import clsx from 'clsx';
import type * as React from 'react';

import { BlockDiffChangeType } from '@gitbook/doc-core';

import { DIFF_TEXT_COLORS } from '../../Diff';

/**
 * Show a vertical line next to a block when diffing.
 */
export function BlockDiffLine(props: {
    children?: React.ReactNode;
    diff: BlockDiffChangeType;
    style?: React.CSSProperties;
}) {
    const { children, diff, style } = props;

    const label =
        diff === BlockDiffChangeType.Added
            ? 'Added'
            : diff === BlockDiffChangeType.Deleted
              ? 'Deleted'
              : diff === BlockDiffChangeType.ModifiedInside
                ? 'Modified inside'
                : 'Modified';

    return (
        <div
            role="status"
            aria-live="polite"
            aria-label={label}
            contentEditable={false}
            className={clsx(
                'absolute select-none border-r-4 border-r-[currentColor] opacity-50',
                DIFF_TEXT_COLORS[diff]
            )}
            style={{
                ...style,
                overflow: 'visible',
            }}
            data-hide-on-drag
        >
            {children}
        </div>
    );
}
